import React from "react"
import tw from "twin.macro"
import styled from "@emotion/styled"

import { withHeader } from "./withHeader"
import NavigationHeader from "../Navigation/Header/NavigationHeader"
import { Announcement } from "../Announcement/Announcement"
import HeaderAccount from "./HeaderAccount"
import HeaderBrand from "./HeaderBrand"

import { BackgroundContainer, StyledContainer } from "../Styled/Container"
import { PublishedSensor } from "../Search/Sensors/PublishedSensor"

const BgContainer = styled(BackgroundContainer)`
  ${tw`z-40 top-0 bg-transparent`}
  ${({ fixed }) => (fixed ? tw`fixed` : tw`fixed`)}
  ${({ activeGuide }) => (activeGuide ? tw`z-10` : tw`z-40`)}
`
const Announcements = tw.div``

const Container = tw(StyledContainer)`relative flex flex-row justify-between max-w-full mx-auto px-1-6 h-6 md:h-10`
// const Container = tw(StyledContainer)`relative flex flex-row justify-between max-w-xl mx-auto px-1-6 h-6 md:h-10`
// const Desktop = tw.div`hidden md:block`
const Mobile = tw.div`block md:hidden`
const MaskBox = tw.div`sticky w-full top-0 z-0 md:z-20 h-0 md:h-0 bg-transparent`
const Desktop = styled.div`
  ${({ activeCart }) => (activeCart ? tw`` : tw`hidden md:block`)}
  ${({ activeHover }) => (activeHover ? tw`relative md:z-75` : tw``)}
`

export const Header = withHeader(
  ({
    activeHeaderHero,
    position,
    newclass,
    // activeMenu,
    activeHover,
    activeSearch,
    location,
    activeCart,
    activeGuide,
  }): JSX.Element => {
    return (
      <>
        <BgContainer id="headerChange" fixed={position} className={`headerwrap ` + newclass} activeGuide={activeGuide}>
          <>
            <Announcements id="announcement_bar">
              <Desktop activeHover={activeHover} activeCart={activeCart}>
                {!activeSearch ? <Announcement /> : null}
              </Desktop>
              {/* <Mobile>{!activeMenu ? <Announcement /> : null}</Mobile> */}
              <Mobile>
                <Announcement />
              </Mobile>
            </Announcements>
            <Container>
              <NavigationHeader activeHeaderHero={activeHeaderHero} location={location} />
              <HeaderBrand active={activeHeaderHero} activeHover={activeHover} />
              <HeaderAccount activeHeaderHero={activeHeaderHero} location={location} />
            </Container>
            <PublishedSensor />
          </>
        </BgContainer>
        <MaskBox />
      </>
    )
  }
)
